import { Component, Inject, inject, signal } from '@angular/core';
import { doc, Firestore, getDoc } from '@angular/fire/firestore';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { filter, Subject, take, takeUntil } from 'rxjs';
import { CommonVariable } from 'src/app/app.constants';
import { AppPaymentService } from 'src/app/services/AppRootService/app-payment.service';

@Component({
  selector: 'app-exit-intent-popup',
  imports: [TranslatePipe],
  templateUrl: './exit-intent-popup.html',
  styleUrl: './exit-intent-popup.scss'
})
export class ExitIntentPopup {
  private authService = inject(AuthService);
  public translate = inject(TranslateService);
  public firestore = inject(Firestore);
  private appPaymentService = inject(AppPaymentService)
  public route = inject(ActivatedRoute);
  private destroy$ = new Subject<void>();
  preferredCurrencySignal = signal<string>(CommonVariable.preferredCurrency);
  currencySymbolSignal = signal<string>(CommonVariable.defaultCurrencySymbol);
  selectedLanguageSignal = signal<string>(CommonVariable.preferredLanguage);
  currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  preferredCurrency: string = CommonVariable.preferredCurrency;
  selectedLanguage: string = CommonVariable.preferredLanguage;
  offerData: Data = null;
  constructor(@Inject(MAT_DIALOG_DATA) public data: Data,
    private dialogRef: MatDialogRef<ExitIntentPopup>, private router: Router) {
    this.authService.selectedlanguage$?.pipe(takeUntil(this.destroy$))?.subscribe({
      next: (l) => {
        if (l) {
          this.selectedLanguageSignal.set(l ? l : CommonVariable?.preferredLanguage);
          this.selectedLanguage = this.selectedLanguageSignal();
          this.translate.use(l ? l : CommonVariable?.preferredLanguage);
        }
      },
      error: (err) => {
        return err;
      },
    });
    this.authService?.userDetails$?.pipe(takeUntil(this.destroy$))?.subscribe({
      next: (user) => {
        this.preferredCurrencySignal.set(user?.preferred_currency ?? CommonVariable.preferredCurrency);
        this.preferredCurrency = this.preferredCurrencySignal();
        this.authService.getCurrencyList$?.pipe(takeUntil(this.destroy$))?.subscribe({
          next: (data: Data) => {
            const CurrencyDetails = data?.details?.find((x) => x?.currency_code === this.preferredCurrencySignal());
            this.currencySymbolSignal.set(CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol);
            this.currencySymbol = this.currencySymbolSignal();
          },
          error: (error) => {
            return error;
          },
        });
      },
      error: (err) => {
        return err;
      },
    });

  }
  ngOnInit() {
    this.getOfferData();
  }
  getOfferData() {
    if (!this.data?.offerId) {
      return;
    }
    const offerDocRef = doc(
      this.firestore,
      `general_modules/offer_listing_v1/offers/${this.data.offerId}`
    );
    getDoc(offerDocRef)
      .then((res) => {
        if (res.exists()) {
          this.offerData = res.data();
          const payload = {
            price: this.offerData?.price ?? null,
            currencySymbol: this.currencySymbol ?? null
          };

          localStorage.setItem(
            'exit_intent_offer_meta',
            JSON.stringify(payload)
          );
        } else {
          return "No offer found for ID"
        }
      })
      .catch((error) => {
        return error;
      });
  }

  // Exit toback page 
  backToPreviousPage() {
    this.dialogRef.close(true);
  }
  async close() {
    const queryParam = this.route.snapshot.queryParams || {};
    this.dialogRef.close(false);
    await this.router.navigate(
      ['mainTabs/tabs/store'],
      {
        queryParams: {
          payment: this.data.offerId,
          ...queryParam
        }
      }
    );
    this.route.queryParams
      .pipe(
        filter((params) => params?.payment || params?.hofferid),
        take(1),
        takeUntil(this.destroy$)
      )
      ?.subscribe((params) => {
        this.appPaymentService.initiatePayment(params);
      });

  }

  onDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
